// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3QOh-","content":"Consent_content__ssfsc","footer":"Consent_footer__o5QUM"};